export function isBoostingPage(page) {
    return !!(page && page.network === 'facebook' && !page.isGroup && page.story_config && page.story_config.created)
}
